import React from 'react';
import {
  Card,
  CardHeader,
  CardSection,
  SmallHeader,
  Suspense,
} from '@axiom/ui';

import { PreferredWeeklyHours } from '../PreferredWeeklyHours/PreferredWeeklyHours';
import { InterviewAvailability } from '../InterviewAvailability/InterviewAvailability';

export type AvailabilityPreferencesProps = {};

export const AvailabilityPreferences = (
  props: AvailabilityPreferencesProps
) => {
  return (
    <Card name="profile-view-availability-preferences">
      <CardHeader>
        <SmallHeader name="PENDO-MY-WORK-INFO">Availability</SmallHeader>
      </CardHeader>
      <CardSection divider>
        <PreferredWeeklyHours />
      </CardSection>
      <CardSection>
        <Suspense>
          <InterviewAvailability />
        </Suspense>
      </CardSection>
    </Card>
  );
};
